import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/svg/star.svg")